import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    alreadyDecrypted: { type: Boolean, default: false },
  };

  connect() {
    console.debug('Decrypt controller connected');

    this.alreadyDecryptedValue = false;

    this._onVaultOpened = async () => {
      console.debug('Attempting decryption on vault-opened event');
      await this.decryptContent();
    };
    this._onLoad = async () => {
      console.debug('Attempting decryption on load event');
      await this.decryptContent();
    };
    this._onTurboLoad = async () => {
      console.debug('Attempting decryption on turbo:load event');
      await this.decryptContent();
    };

    window.addEventListener('vault-opened', this._onVaultOpened);
    window.addEventListener('load', this._onLoad);
    document.addEventListener('turbo:load', this._onTurboLoad);

    // Immediate attempt (covers "vault already open" + DOM already there)
    console.debug('Attempting decryption on controller connect');
    this.decryptContent();
  }

  disconnect() {
    window.removeEventListener('vault-opened', this._onVaultOpened);
    window.removeEventListener('load', this._onLoad);
    document.removeEventListener('turbo:load', this._onTurboLoad);
  }

  srcToFile(src, fileName, mimeType) {
    return fetch(src)
      .then((res) => res.arrayBuffer())
      .then((buf) => new File([buf], fileName, { type: mimeType }));
  }

  async decryptContent() {
    if (this.alreadyDecryptedValue) {
      console.debug('Decryption skipped - already decrypted');
      return;
    }
    if (!window.vault?.is_open?.()) {
      console.debug('Decryption skipped - vault missing or closed');
      return;
    }

    // Keep your original page guard
    if (!new URLSearchParams(window.location.search).get('rbf_claim_template_id')) {
      console.debug('Decryption skipped - not an edit flow (missing rbf_claim_template_id)');
      return;
    }

    console.debug('Decryption started...');
    this.alreadyDecryptedValue = true;

    const decrypt_inputs = async () => {
      for (const input of document.querySelectorAll('input')) {
        const raw = input.getAttribute('value');
        if (/\d*:.*:.*/.exec(raw)) {
          input.value = await window.vault.decryptMessage(raw);
        }
      }

      for (const option of document.querySelectorAll('option')) {
        const raw = option.getAttribute('value');
        if (/\d*:.*:.*/.exec(raw)) {
          const decrypted = await window.vault.decryptMessage(raw);
          option.value = decrypted;
          option.textContent = decrypted;
        }
      }

      for (const holder of document.querySelectorAll('.image-preview-container .hidden')) {
        const encrypted = holder.getAttribute('data');
        const name = holder.getAttribute('name');

        const image_data = await window.vault.decryptMessage(encrypted);
        if (!image_data) {
          console.log('image data is null - skipping!');
          continue;
        }

        const input = name ? document.getElementById(name) : null;

        if (input && input.type === 'file') {
          const file = await this.srcToFile(image_data, name, /data:(.*);.*/.exec(image_data)?.[1]);

          const dt = new DataTransfer();
          dt.items.add(file);
          input.files = dt.files;

          const controllerEle = input.closest('.camera-field');
          if (controllerEle && window.Stimulus) {
            const controller = window.Stimulus.getControllerForElementAndIdentifier(
              controllerEle,
              'dynform--photo'
            );
            controller?.handleImageSelect?.({ target: { files: [file] }, prefill: true });
            continue;
          }
        }

        const container = holder.closest('.image-preview-container');
        const img = container?.querySelector('img');
        if (img) img.src = image_data;
      }
    };

    if (!window.vault.is_open()) {
      window.vault.openModal(decrypt_inputs);
    } else {
      await decrypt_inputs();
    }
  }
}
